export default "__VITE_ASSET__Lnq5KrpI__"